var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSergeant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M502.261 190.164l9.739-4.973 9.739 4.973 502.261 260.738v387.907l-512-261.447-512 261.447v-387.907l12.522-6.394 489.739-254.343zM979.478 478.609l-467.478-242.265-467.478 242.265v58.967l467.478-238.712 467.478 238.712v-58.967zM512 350.017l467.478 238.711v62.521l-467.478-238.712-467.478 238.712v-62.521l467.478-238.711zM979.478 702.401l-467.478-238.712-467.478 238.712v62.521l467.478-238.712 467.478 238.712v-62.521z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSergeant);
export default __webpack_public_path__ + "static/media/sergeant.4a996e71790ca0da0dda98267b120b1c.svg";
export { ForwardRef as ReactComponent };